import PropTypes from 'prop-types'

import { Icon } from '@mc/design-system'

const EmailInputError = ({ error, className = '' }) => (
  <div className={`d-flex align-items-center ${className}`}>
    <Icon kind='error' className='mc-icon--3 mc-text--error' />
    <p aria-live='assertive' className='mc-text--error mc-text-x-small'>
      {error}
    </p>
  </div>
)

EmailInputError.propTypes = {
  className: PropTypes.string,
  error: PropTypes.string.isRequired,
}

export default EmailInputError
